var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "27) Icon/close-circle-fill"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0237 44.3097C50.327 45.613 50.327 47.7197 49.0237 49.023C48.3737 49.673 47.5203 49.9997 46.667 49.9997C45.8137 49.9997 44.9603 49.673 44.3103 49.023L40.0003 44.713L35.6903 49.023C35.0403 49.673 34.187 49.9997 33.3337 49.9997C32.4803 49.9997 31.627 49.673 30.977 49.023C29.6737 47.7197 29.6737 45.613 30.977 44.3097L35.287 39.9997L30.977 35.6897C29.6737 34.3864 29.6737 32.2797 30.977 30.9764C32.2803 29.673 34.387 29.673 35.6903 30.9764L40.0003 35.2864L44.3103 30.9764C45.6137 29.673 47.7203 29.673 49.0237 30.9764C50.327 32.2797 50.327 34.3864 49.0237 35.6897L44.7137 39.9997L49.0237 44.3097ZM40.0003 6.66638C21.6203 6.66638 6.66699 21.6197 6.66699 39.9997C6.66699 58.3797 21.6203 73.333 40.0003 73.333C58.3803 73.333 73.3337 58.3797 73.3337 39.9997C73.3337 21.6197 58.3803 6.66638 40.0003 6.66638Z",
    fill: "#EE7777"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_317_385",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 68,
    height: 68
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0237 44.3097C50.327 45.613 50.327 47.7197 49.0237 49.023C48.3737 49.673 47.5203 49.9997 46.667 49.9997C45.8137 49.9997 44.9603 49.673 44.3103 49.023L40.0003 44.713L35.6903 49.023C35.0403 49.673 34.187 49.9997 33.3337 49.9997C32.4803 49.9997 31.627 49.673 30.977 49.023C29.6737 47.7197 29.6737 45.613 30.977 44.3097L35.287 39.9997L30.977 35.6897C29.6737 34.3864 29.6737 32.2797 30.977 30.9764C32.2803 29.673 34.387 29.673 35.6903 30.9764L40.0003 35.2864L44.3103 30.9764C45.6137 29.673 47.7203 29.673 49.0237 30.9764C50.327 32.2797 50.327 34.3864 49.0237 35.6897L44.7137 39.9997L49.0237 44.3097ZM40.0003 6.66638C21.6203 6.66638 6.66699 21.6197 6.66699 39.9997C6.66699 58.3797 21.6203 73.333 40.0003 73.333C58.3803 73.333 73.3337 58.3797 73.3337 39.9997C73.3337 21.6197 58.3803 6.66638 40.0003 6.66638Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_317_385)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.95eabd8a7c915ce7d953832824064bae.svg";
export { ForwardRef as ReactComponent };